import { Bell } from "@phosphor-icons/react";
import { useNavigate } from "react-router-dom";
import { formatChatTimestamp } from "../lib/timeFormat";

/**
 * Inline confirmation chip rendered below the assistant message that just
 * created a reminder. Tap to navigate to /reminders.
 */
export default function ReminderCreatedChip({ reminder, tz }) {
  const navigate = useNavigate();
  if (!reminder) return null;
  const when = formatChatTimestamp(reminder.remind_at, tz);
  return (
    <button
      onClick={() => navigate("/app/reminders")}
      className="mt-2 inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-cyan-500/10 border border-cyan-500/30 hover:bg-cyan-500/15 hover:border-cyan-500/50 transition-colors text-xs text-cyan-300"
      data-testid={`reminder-chip-${reminder.id}`}
    >
      <Bell size={12} weight="duotone" className="text-cyan-400" />
      <span>
        Reminder set ·{" "}
        <span className="text-cyan-200 font-medium">{when}</span>
      </span>
    </button>
  );
}
